import { actionTypes } from './bookmakersSwitcher.actions';

export default (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_REDIRECT_LOGIN_BOOKMAKER:
            return {
                ...state,
                redirectToLoginBookmaker: action.feed,
            };
        case actionTypes.CLEAR_REDIRECT_LOGIN_BOOKMAKER:
            return {
                ...state,
                redirectToLoginBookmaker: null,
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/bookmakersSwitcherInfo.reducer.js